import React from 'react';
import { TORB4BackendRecord } from 'redux/app/orb4/@types';
import ORB4TableRows from '../ORB4TableRows';
import getSignTableRows from '../getSignTableRows';
type OwnProps = {
    isSubmitterChiefOrMaster: boolean;
    orb4Record: TORB4BackendRecord;
    theme?: "light" | "dark";
};
type ORB4RecordParticipantsViewProps = OwnProps;
function ORB4RecordParticipantsView(props: ORB4RecordParticipantsViewProps) {
    const { orb4Record } = props;

    return (
        <ORB4TableRows
            record={orb4Record}
            tableRows={getSignTableRows(orb4Record)}
        />
    );
}

export default ORB4RecordParticipantsView;
